import { ColorCircle } from "@/src/components/colorCircle";
import { AppointmentType } from "@/src/data/allTypes";
import { uid } from "@/src/utils/utils";

export default function AppointmentTypeCard({
  isActive,
  type,
  onClick,
}: {
  isActive: boolean;
  type: AppointmentType;
  onClick: () => void;
}) {
  return (
    <div
      key={uid()}
      className="card grid c1 gap10"
      style={{
        background: isActive ? type.color : "white",
        color: isActive ? "white" : "",
      }}
      onClick={() => {
        onClick();
      }}
    >
      <div className="cauto-1 acenter gap10">
        <ColorCircle color={isActive ? "white" : type.color}></ColorCircle>
        {type.name}
      </div>
    </div>
  );
}
